import Button from "../../Shared/Button/Button";

const MyListingOffersOptions = () => {
  return (
    <div className="flex w-full items-center justify-center border-l border-lightGray">
      <Button text={"View Offer"} variant="primary" />
    </div>
  );
};

export default MyListingOffersOptions;
